import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import PWAModal from '../../components/PwaModal.tsx';
import { JournalContextProvider } from '../../contexts/journal.tsx';
import JournalBody from './body.tsx';
import { JournalEdit } from './components/journalEdit.tsx';
import JournalHeader from './header.tsx';

const Journal = () => {
    var { dateTime } = useParams();
    const showModal = useMemo(() => { //Show modal 10% of the time
        const random = Math.floor(Math.random() * 10);
        return random == 0;
    }, []);
    return (
        <JournalContextProvider>
            {showModal &&
                <PWAModal />
            }
            <JournalHeader />
            {!dateTime
                ? <JournalBody />
                : <JournalEdit />
            }
        </JournalContextProvider>
    );
};

export default Journal;
